/**
 * This class is used to create a worker using `importScripts` for loading a script from a different origin.
 * @see https://github.com/webpack/webpack/discussions/14648#discussioncomment-1589272
 *
 * When using with Webpack, alias CORSWorker to Worker to make the import statically analyzable.
 *
 * e.g.
 *  import Worker from 'CORSWorker';
 *
 *  const corsWorker = new Worker(new URL('my-worker.ts', import.meta.url));
 *  const worker = corsWorker.getWorker();
 */
export default class CORSWorker {
  private readonly worker: Worker;

  constructor(url: string | URL) {
    const objectURL = URL.createObjectURL(
      new Blob([`importScripts(${JSON.stringify(url.toString())});`], {
        type: "application/javascript",
      }),
    );
    this.worker = new Worker(objectURL);
    URL.revokeObjectURL(objectURL);
  }

  getWorker() {
    return this.worker;
  }
}
